import { Link } from "react-router-dom";

function BlogCard({ title, description, link, image, handleFooterLink, date, author }) {
  let introContent = '';

  const contentWithoutTags = (description || '').replace(/<[^>]*>/g, ' ');
  const firstParagraphEnd = contentWithoutTags.indexOf('\n\n');
  
  if (firstParagraphEnd > 0) {
    introContent = contentWithoutTags.substring(0, firstParagraphEnd);
  } else {
    introContent = contentWithoutTags.substring(0, 200) + '...';
  }

  const displayAuthor = author || "Pluro Jabalpur Fertility Center";

  return (
    <div className="col-12 col-lg-4 col-md-6 mb-4">
      <Link to={link} onClick={handleFooterLink} className="text-white text-decoration-none">
        <div className="card shadow p-3 mb-5 bg-white rounded h-100 d-flex flex-column justify-content-between">
          <div>
            <img 
              src={image} 
              className="card-img-top" 
              alt={title} 
              style={{ objectFit: "cover", width: "100%", height: "15rem", borderRadius: "8px" }} 
            />
            <div className="card-body px-0">
              <h5 className="card-title mt-2" style={{ color: "#f58220" }}>{title}</h5>
              <p className="card-text text-secondary" dangerouslySetInnerHTML={{ __html: introContent }}></p>
            </div>
          </div>
          <div className="pt-2 border-top d-flex justify-content-between align-items-center text-muted" style={{ fontSize: "0.75rem" }}>
            <span className="fw-medium text-dark">
              <i className="fa fa-user me-1 text-primary"></i> {displayAuthor}
            </span>
            {date && <em>{date}</em>}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default BlogCard;
